import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import Utils from "../../../provider/Utils";
import Button from "@mui/material/Button";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import FetchServerData from "../../../provider/FetchServerData";
import StripeLogo from "../../../assets/img/StripeLogo.png";
import PtsAlert from "../ptsAlert/PtsAlert";

const styles = {
  form: {
    maxWidth: "500px",
    margin: "2rem auto",
    padding: "24px",
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    backgroundColor: "#fff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
  },

  field: {
    marginBottom: "16px",
  },
  label: {
    display: "block",
    marginBottom: "2px",
    marginLeft: "2px",
    fontWeight: "600",
    color: "#4a5568",
    textAlign: "left",
  },
  input: {
    width: "100%",
    padding: "10px",
    border: "1px solid #cbd5e0",
    borderRadius: "6px",
    fontSize: "14px",
    boxSizing: "border-box",
  },
  inputBox: {
    border: "1px solid #cbd5e0",
    padding: "10px",
    borderRadius: "6px",
    backgroundColor: "#f7fafc",
  },
  row: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    marginBottom: "16px",
  },

  error: {
    color: "#e53e3e",
    marginTop: "12px",
  },
  success: {
    color: "#38a169",
    marginTop: "12px",
  },
};

class RegCreditCardForm extends Component {
  constructor(props) {
    const registration = props.registration;
    const selectedPlan = props.selectedPlan;
    super(props);
    this.state = {
      selectedPlan: selectedPlan,
      email: registration?.email,
      tenant: registration?.tenant,
      cardName: props.cardName,
      cardId: "",
      cardNumber: "",
      expiryDate: "",
      cvvCode: "",
      render: false,
      isPerEvent: props.isPerEvent,
      processing: false,
      acceptTermsConditionCheckbox: props.acceptTermsConditionCheckbox,
      error: null,
      success: false,
      isCardSelected: false,
      billingDetails: {
        name: "",
      },
      onSuccessPayment: props.onSuccessPayment,
      creditCardList: [],
      creditCard: null,
    };
  }

  handleCardNumberChange(e) {
    let number = Utils.formatCardNumber(e.target.value);
    this.setState({ cardNumber: number });
  }
  handleCardNameChange(e) {
    this.setState({ cardName: e.target.value });
  }

  handleCvvCodeChange(e) {
    this.setState({ cvvCode: e.target.value });
  }

  handleExpiryDateChange(e) {
    let digits = e.target.value.replace(/[^0-9]/g, "");
    if (digits.length > 4) digits = digits.slice(0, 4);

    let formatted = digits;
    let month = "",
      year = "";

    if (digits.length > 2) {
      month = digits.slice(0, 2);
      year = digits.slice(2);
      formatted = month + "/" + year;
    }

    this.setState({
      expiryDate: formatted, // in MM/YY
      cardMonth: month,
      cardYear: year,
    });
  }
  handleInputChange(event) {
    const { name, value } = event.target;

    this.setState((prevState) => ({
      billingDetails: {
        ...prevState.billingDetails,
        [name]: value,
      },
    }));
  }

  async onPaymentSuccess(paymentIntent) {
    const postObject = {
      header: {
        userid: this.state.email,
        tid: this.state.tenant?.id,
        appclient: "W",
      },
      plan: { id: this.state.selectedPlan?.id },
      clientSecret: paymentIntent.client_secret,
      paymentIntentId: paymentIntent.id,
      cardName: this.state.cardName,
    };
    await FetchServerData.callPostService(
      "/regms/paymentSuccessful",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let orderPayment = output.data.orderPayment;
        if (orderPayment.isError) {
          this.setState({
            error: orderPayment.errorText,
            processing: false,
          });
        } else {
          this.props.navigate("/verifyAccount", {
            state: {
              email: this.state.email,
              orderPaymentId: orderPayment?.id,
            },
          });
        }
      } else {
      }
    });
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    if (!this.props.acceptTermsConditionCheckbox) {
      window.scroll(0, 0);
      PtsAlert.error("Please select the checkbox to continue.");
      return;
    }
    const { stripe, elements } = this.props;
    this.setState({ processing: true, error: null });

    if (!stripe || !elements) {
      this.setState({
        error: "Stripe.js has not loaded yet.",
        processing: false,
      });
      return;
    }

    // Step 1
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardNumberElement),
      billing_details: { name: this.state.cardName },
    });

    if (error) {
      this.setState({
        error: error.message,
        processing: false,
      });
      return;
    } else {
      // Step 2  Backend call to create client secret
      const postObject = {
        header: {
          userid: this.state.email,
          tid: this.state.tenant?.id,
          appclient: "W",
        },
        plan: { id: this.state.selectedPlan?.id },
        paymentMethodId: paymentMethod.id,
        cardName: this.state.cardName,
      };
      const resp = await FetchServerData.callPostService(
        "/regms/createSecret",
        postObject
      );
      const clientSecret = resp.data.clientSecret;
      if (resp.status === "FAIL") {
        this.setState({
          error: resp.errorCode + resp.message,
          processing: false,
        });

        return;
      } else {
        // Step 3 Confirm the payment with card
        const result = await stripe.confirmCardPayment(clientSecret);

        if (result.error) {
          this.setState({
            error: result.error.message,
            processing: false,
          });
          return;
        }

        if (result && result.paymentIntent) {
          this.onPaymentSuccess(result.paymentIntent);
        }

        this.setState({ processing: false });
      }
    }
  };

  addNewCreditCard = async (event) => {
    event.preventDefault();
    const { stripe, elements } = this.props;
    this.setState({ processing: true, error: null });

    if (!stripe || !elements) {
      this.setState({
        error: "Stripe.js has not loaded yet.",
        processing: false,
      });
      return;
    }

    // Step 1
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardNumberElement),
      billing_details: { name: this.state.cardName },
    });

    if (error) {
      this.setState({
        error: error.message,
        processing: false,
      });
      return;
    } else {
      // Step 2  Backend call to create client secret
      const postObject = {
        header: {
          userid: this.state.email,
          tid: this.state.tenant?.id,
          appclient: "W",
        },
        paymentMethodId: paymentMethod.id,
        isDefault: true,
      };
      const resp = await FetchServerData.callPostService(
        "/paymentms/addCardForReg",
        postObject
      );
      if (resp.status === "SUCCESS") {
        this.setState({ processing: false });
        this.props.navigate("/verifyAccount", {
          state: {
            email: this.state.email,
          },
        });
      } else {
      }
    }
  };

  render() {
    return (
      <div className="row d-flex align-item-stretch">
        <div class="col-md-8 align-self-center">
          <form
            onSubmit={
              this.state.isPerEvent
                ? this.addNewCreditCard.bind(this)
                : this.handleSubmit.bind(this)
            }
            style={styles.form}
          >
            <div className="row">
              <div className="col-sm-12">
                <h4>Pay with card.</h4>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <label className="form-label">Name on Card</label>
                <input
                  name="name"
                  value={this.state.cardName}
                  onChange={this.handleCardNameChange.bind(this)}
                  required
                  style={styles.input}
                  placeholder=""
                />
              </div>
            </div>

            <div className="row  mt-3">
              <div className="col-md-12">
                <label className="form-label">Card Number</label>
                <div style={styles.inputBox}>
                  <CardNumberElement options={{ placeholder: "" }} />
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-md-6">
                <label className="form-label">Expiration Date (MM/YY)</label>
                <div style={styles.inputBox}>
                  <CardExpiryElement options={{ placeholder: "" }} />
                </div>
              </div>
              <div className="col-md-6">
                <label className="form-label">CVV</label>
                <div style={styles.inputBox}>
                  <CardCvcElement options={{ placeholder: "" }} />
                </div>
              </div>
            </div>
            <div class="row text-center mt-3">
              <div className="col-sm-12">
                <Button
                  style={{
                    background: this.state.processing
                      ? "#73acda"
                      : "rgb(33, 148, 242)",
                    color: "rgb(255, 255, 255)",
                    borderBottom: "3px solid rgb(99, 98, 98)",
                    borderRadius: "5px",
                    padding: "2px 10px",
                    fontSize: "20px",
                    fontWeight: "700",
                    textTransform: "none",
                    width: "100%",
                  }}
                  type="submit"
                // disabled={this.state.processing}
                >
                  {this.state.isPerEvent
                    ? "Add Card"
                    : `Register my account and charge card $${this.state.selectedPlan?.price}`}
                </Button>
              </div>
            </div>
            {this.state.error && (
              <div className="row" style={{ color: "#e53e3e" }}>
                <div className="col-sm-12">{this.state.error}</div>
              </div>
            )}
            {this.state.success && (
              <div className="row" style={{ color: "#38a169" }}>
                <div className="col-sm-12">Card saved successfully!</div>
              </div>
            )}
            <div className="row mt-2">
              <div className="col-sm-12">
                <img src={StripeLogo} style={{ width: "75px" }} />
              </div>
              <div className="col-sm-12">
                <p className="mb-0" style={{ fontSize: "12px" }}>
                  Credit card information and payments are securely managed by
                  Stripe.
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
export default withRouter(RegCreditCardForm);
